import { render, staticRenderFns } from "./RegistroSobrevivencia.vue?vue&type=template&id=1ae5d8fc&scoped=true"
import script from "./RegistroSobrevivencia.vue?vue&type=script&lang=ts"
export * from "./RegistroSobrevivencia.vue?vue&type=script&lang=ts"
import style0 from "./RegistroSobrevivencia.vue?vue&type=style&index=0&id=1ae5d8fc&prod&lang=css"
import style1 from "./RegistroSobrevivencia.vue?vue&type=style&index=1&id=1ae5d8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae5d8fc",
  null
  
)

export default component.exports